import myNetwork from '@/mycore/network/apimanagement';
import * as api from '../../../mycore/module/api';
import {SERVICE_PAGE_TYPE} from '@/configs/constants';
export function getCloudDetail(callback, service_code) {
    myNetwork
        .post('/api/cms/cloud', { service_code })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}

export function createOrderCloud(callback, data) {
    api.createOrderCloud(callback, data);
}

export function updatePackageOrder(ordercode, prepaidTime, listPackage, service_code = 'cloud') {
    api.updatePackageOrder(
        service_code,
        ordercode,
        prepaidTime,
        listPackage,
    );
}

export function getCategories(callback) {
    let location = {
        locationid: '8',
        districtid: '1',
        wardid: '1',
    }
    const locationData = sessionStorage.getItem('dataLocation') || localStorage.getItem('dataLocation');
    if(locationData) {
        location = JSON.parse(locationData);
    }
    myNetwork.post('/api/saleplatform/catalog/get-categories', {
            'SaleTeamId': parseInt(sessionStorage.SaleTeamId) || 29,
            'CusTypeId': 102,
            'CusTypeL2Id': 132,
            'LocationId': parseInt(location.locationid || 8),
            'DistrictId': parseInt(location.districtid || 1),
            'WardId': parseInt(location.wardid || 1),
            'PageType': SERVICE_PAGE_TYPE.CLOUD,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        })
}
export function checkPassport(callback, passport, type, g_recaptcha_response) {
    api.checkPassport(callback, passport, type, g_recaptcha_response);
}

export function getPackagesFee(callback, serviceCode, locationid = 8) {
    api.getPackagesFee(callback, serviceCode, locationid = 9);
}

export function getOrderInfo(callback, ordercode) {
    api.getOrderInfo(callback, ordercode);
}

export function updateContractsRefferal(callback, ordercode, ContractRefInfo) {
    api.updateContractsRefferal(callback, ordercode, ContractRefInfo);
}

export function getCategoriesDisplayType(callback, locationId = 8, district = 'Q1', source) {
    api.getCategoriesDisplayType(callback, '5', locationId, district, source);
}
export function getCategoryDetail(callback, data) {
    myNetwork
        .post('/api/saleplatform/catalog/get-category-detail', {...data
        })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, {
                message: error
            });
        });
}
export function getSetting(callback, orderid) {
    myNetwork.post('/api/saleplatform/configuration/get-saleteam-setting', {
            OrderID: orderid,
            BillType: 3,
            SaleTeamId: parseInt(sessionStorage.SaleTeamId) || 29,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getOrderDetail(callback, orderid) {
    api.getOrderDetail(callback, orderid);
}


export function getCategoryDetailNoneId(callback, {CategoryServices : CategoryServices, SysName : SysName}) {
    api.getCategoryDetailNoneId(callback, {CategoryServices : CategoryServices, SysName : SysName});
}
export function getServiceFromName(callback, routerName) {
    api.getServiceFromName(callback, routerName);
}
export function updateCloudPackages(callback, data) {
    api.updateOrderDetail(callback, data)
}

export function getPaymentMethod(callback, orderid) {
    api.getPaymentMethod(callback, orderid)
}
